module.exports = __webpack_public_path__ + "img/Logo_CCQC_Gris.c0c3fde1.png";